



(function () {
    document.addEventListener("DOMContentLoaded", function () {
        var atk = new ApplyThemeKeywords();
    });
})();


export class ApplyThemeKeywords {
    private initialised: boolean = false;

    private _themeKeywords: Array<ThemeKeyword>;

    constructor() {
        this.init();
    }

    private init = () => {
        if (this.initialised) {
            return;
        }
        this.apply();
        this.initialised = true;
    }

    private apply = (): void => {
        let self = this;

        self._themeKeywords = new Array<ThemeKeyword>();

        var callback = function (result) {
            $.each(result, function (i, field) {
                self._themeKeywords.push(new ThemeKeyword(field.keyword, field.themeUrl));
            });
            
            $('.applyThemeKeywords').each(function (i: number, element: HTMLElement) {
                self.applyToHtml(element);
            });
        };

        $.getJSON("/api/Themes/ThemeKeywords", callback).fail(function () {
            console.error("Error calling /api/Themes/ThemeKeywords");
        });        
    }

    private applyToHtml = (element: HTMLElement) : void => {
        for (let tk of this._themeKeywords) {            
                //console.log(tk.keyword);
                element.innerHTML = element.innerHTML.replace(new RegExp(`(\\b${tk.keyword}\\b)`, "gi"), `<a href='${tk.themeUrl}'>$1</a>`);            
        }
    }
}



export class ThemeKeyword {   
    constructor(public keyword: string, public themeUrl: string) {       
    }
}